module.exports = __webpack_public_path__ + "static/media/website-09.22ecb9e5.mp4";